import { GetBillingCyclesResponseSchema, type GetBillingCyclesResponse } from '@weft/api-definition';
import { getPrivateApi } from 'apps/app/src/services/api';
import { useQuery } from 'react-query';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { BILLING_CYCLE_OVERVIEW_PAGE_SIZE } from './use-billing-cycle-overview-consts';

export function useBillingCyclesOverview(options?: CustomUseQueryOptions<GetBillingCyclesResponse>) {
  return useQuery(
    ['billingCyclesOverview'],
    async () => {
      const billingCyclesApi = getPrivateApi();
      const getBillingCyclesResponse = await billingCyclesApi.getBillingCycleOverviews({ pageSize: BILLING_CYCLE_OVERVIEW_PAGE_SIZE });

      return GetBillingCyclesResponseSchema.parse(getBillingCyclesResponse);
    },
    { suspense: true, ...options },
  );
}